// client-side analytics helper
import CryptoJS from 'crypto-js';

const ANALYTICS_ENDPOINT = '/api/analytics';

async function getIpInfo() {
  try {
    const res = await fetch('https://ipapi.co/json/');
    if (!res.ok) return null;
    const data = await res.json();
    return data; // contains ip, city, region, country_name, country_code
  } catch (e) {
    return null;
  }
}

async function postAnalytics(payload) {
  try {
    await fetch(ANALYTICS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    // silent
  }
}

export async function initAnalytics() {
  try {
    const ipInfo = await getIpInfo();
    const ip = ipInfo?.ip || '';
    const city = ipInfo?.city || '';
    const country = ipInfo?.country_name || ipInfo?.country || '';

    const ipHash = ip ? CryptoJS.SHA256(ip).toString() : '';
    
    // Parse the URL search params for UTM tracking or source param
    const urlParams = new URLSearchParams(window.location.search);
    const sourceParam = urlParams.get('source') || urlParams.get('ref') || urlParams.get('utm_source');
    
    // Prepare the referrer string
    let rawReferrer = sourceParam || document.referrer || '';
    let formattedReferrer = rawReferrer;

    if (rawReferrer) {
      const lowerRef = rawReferrer.toLowerCase();
      if (lowerRef.includes('linkedin')) formattedReferrer = 'LinkedIn';
      else if (lowerRef.includes('github')) formattedReferrer = 'GitHub';
      else if (lowerRef.includes('naukri')) formattedReferrer = 'Naukri';
      else if (lowerRef.includes('twitter') || lowerRef.includes('t.co') || lowerRef.includes('x.com')) formattedReferrer = 'Twitter / X';
      else if (lowerRef.includes('resume') || lowerRef.includes('pdf')) formattedReferrer = 'Resume';
      else if (lowerRef.includes('google')) formattedReferrer = 'Google Search';
      else if (rawReferrer.startsWith('http')) {
        try { 
            formattedReferrer = new URL(rawReferrer).hostname.replace('www.', ''); 
        } catch(e) {}
      }
    }

    const payload = {
      ipHash,
      city,
      country,
      platform: navigator.platform || '',
      userAgent: navigator.userAgent || '',
      page: window.location.pathname + window.location.search,
      referrer: formattedReferrer,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      timestamp: new Date().toISOString(),
    };

    postAnalytics(payload);
  } catch (e) {
    // ignore
  }
}

// Auto-init on import (runs once on client)
if (typeof window !== 'undefined') {
  // defer slightly to avoid blocking render
  setTimeout(() => {
    initAnalytics();
  }, 500);
}

export default { initAnalytics };
